import {
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { memo, useCallback } from 'react';
import VirtualisedListWrapper from '../../../../common-components/virtualised-list/virtualised-list';
import { NearbyVesselItem } from '../nearby-vessels-data.types';

interface NearbyVesselsResultsProps {
  results: NearbyVesselItem[];
}

function NearbyVesselRow({ vessel }: { vessel: NearbyVesselItem }) {
  return (
    <ListItem
      alignItems="flex-start"
      disableGutters
      disablePadding
      sx={{
        borderBottom: '1px solid',
        borderBottomColor: 'background.paper',
      }}
    >
      <ListItemButton>
        <ListItemText
          primary={vessel.name ?? 'No Name'}
          secondary={
            <Typography component="span" variant="body2">
              {vessel.mmsi && (
                <>
                  <b>MMSI</b> {vessel.mmsi}{' '}
                </>
              )}
              {vessel.imo && (
                <>
                  <b>IMO</b> {vessel.imo}
                </>
              )}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}

function NearbyVesselsResults({ results }: NearbyVesselsResultsProps) {
  const renderRow = useCallback(
    (index: number) => <NearbyVesselRow vessel={results[index]} />,
    [results]
  );

  return (
    <VirtualisedListWrapper
      items={results}
      selectedItemIndex={null}
      listContent={renderRow}
    />
  );
}

export default memo(NearbyVesselsResults);
